import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { id: "main-content" }
const _hoisted_3 = {
  class: "primary list-primary",
  ref: "box"
}
const _hoisted_4 = { class: "entry-item box-hover clearfix article-list" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "entry-content",
  style: {"text-align":"left"}
}
const _hoisted_8 = { class: "entry-title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "article-other" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "entry-author" }, "发布时间:", -1)
const _hoisted_13 = {
  class: "entry-author",
  href: "#"
}
const _hoisted_14 = { class: "secondary list-secondary" }
const _hoisted_15 = {
  id: "sidebar-b",
  class: "sidebar"
}
const _hoisted_16 = { class: "widget" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("header", { class: "entry-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "widget-title clearfix" }, [
    /*#__PURE__*/_createElementVNode("span", null, "排行榜")
  ])
], -1)
const _hoisted_18 = { class: "older-posts" }
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  id: "back-to-top",
  href: "#",
  class: "btn btn-primary btn-lg back-to-top",
  role: "button",
  title: "Click to return on the top page",
  "data-toggle": "tooltip",
  "data-placement": "left"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-chevron-up" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuoCangHeader = _resolveComponent("GuoCangHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GuoCangHeader, { msg: "Welcome to Your Vue.js + TypeScript App" }),
    _createElementVNode("div", {
      class: "wrapper",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listScroll && _ctx.listScroll(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles.data, (article) => {
              return (_openBlock(), _createElementBlock("article", _hoisted_4, [
                _createElementVNode("a", {
                  href: 'info?id='+article.id
                }, [
                  (article.img !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "hover-effect responsive-img",
                        src: _ctx.imgUrl+article.img,
                        alt: ""
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", _hoisted_8, _toDisplayString(article.title), 1),
                    (article.description.length > 140 )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(article.description.substr(0,140)) + "...", 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(article.description), 1)),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("a", _hoisted_13, _toDisplayString(article.created_at), 1)
                    ])
                  ])
                ], 8, _hoisted_5)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([{isMore: _ctx.isMore }, "more"])
          }, "没有更多了...", 2)
        ], 512),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("aside", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.top.data, (article, index) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("a", {
                      href: 'info?id='+article.id,
                      title: article.title
                    }, _toDisplayString(article.title), 9, _hoisted_19)
                  ]))
                }), 256))
              ])
            ]),
            _hoisted_20
          ]),
          _hoisted_21
        ]),
        _hoisted_22,
        _hoisted_23
      ])
    ], 32)
  ]))
}